import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../Common/Button";
import { Table } from "../Common/Table/Table";
import SubHeaderMenu from "../Sidebar/SubHeaderMenu";
import useNetworkServices from "../../Networking/baseAPIManager";
import { debounce } from "lodash";
import { MdOutlineFilterAlt } from "react-icons/md";
import Dropdown from "../Common/Dropdown";
import Loader from "../Common/Loader";

const CustomerList = () => {
  const location = useLocation();
  const [customerListData, setCustomerListData] = useState([]);
  const [visibleRows, setVisibleRows] = useState(10);
  const [filterData, setFilterData] = useState([]);
  const [offerData, setOfferData] = useState([]);
  const [filterPage, setFilterPage] = useState("1");
  const [filterLimit, setFilterLimit] = useState("10");
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading , setLoading] = useState(false)

  console.log(searchQuery,"searchQuery======>");
  const { customerList } = useNetworkServices();
  const navigate = useNavigate();

  const columns = [
    { header: "Customer ID", accessor: "id" },
    {
      header: "Customer Name",
      accessor: "name",
      customTxt: (data) => {
        return <span>{data.fullName ? data.fullName : "N/A"}</span>;
      },
    },
    { header: "Contact No", accessor: "mobile" },
    { header: "Email Id", accessor: "email" },
    { header: "Gender", accessor: "gender" },
    {
      header: "Action",
      accessor: "",
      customBtn: (data) => {
        console.log("data897897",data)
        return (
          <Button
            type="button"
            label="View Detail"
            className="text-[#025D89]"
            onClick={() => {
              setIsOpen(true);
              setOfferData(data);
              navigate(`/customer_overview/detail`,{state:data._id})
            }}
          />
        );
      },
    },
  ];

  const total_Page = customerListData?.totalPage ?? 10;

  // Create pages dropdown options
  const pages = Array.from({ length: total_Page }, (_, i) => ({
    value: i + 1,
    name: `Page - ${i + 1}`,
  }));

   

  

  const limit = [
    { value: "10", name: "Limit - 10" },
    { value: "25", name: "Limit - 25" },
    { value: "50", name: "Limit - 50" },
  ];

  const getCustomerList = async () => {

    const QueryParams = {
      page:filterPage,
      limit:filterLimit,
  }

  const queryString = new URLSearchParams(QueryParams).toString();
  
    try {
      setLoading(true)
      const response = await customerList(queryString);
      // console.log(response?.data?.data, "response=====>");
      setCustomerListData(response?.data?.data);
     
    } catch (error) {
      console.error(error, "error");
    } finally {
      setLoading(false)
    }
  };
  useEffect(() => {
    getCustomerList();
  }, [filterLimit,filterPage]);

  const handleSearch = debounce((query) => {
    setSearchQuery(query);
  }, 100);
  useEffect(() => {
    if (searchQuery.trim()) {
      const lowerCaseQuery = searchQuery.toLowerCase();
  
      const filteredData = (customerListData.result || []).filter((list) => {
        const fullName = list.fullName?.toLowerCase() || "";
        const id = list.id?.toLowerCase() || "";
  
        return fullName.includes(lowerCaseQuery) || id.includes(lowerCaseQuery);
      });
  
      setFilterData(filteredData);
    } else {
      setFilterData(customerListData.result || []);
    }
  }, [searchQuery, customerListData]);
  


  return (
    <div id="main" className="p-4">
      <h1 className="font-bold text-2xl text-slate-900 pb-5">
        <span>Customer Management</span> /{" "}
        <span className="text-red-500">
          <SubHeaderMenu location={location} />
        </span>
      </h1>
      <div className="w-full flex justify-between items-center pe-5 py-5">
        <div className="flex items-center w-1/2">
          <input
            type="text"
            placeholder="Search by customer ID & name"
            value={searchQuery}
            onChange={(e) => handleSearch(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none"
          />
        </div>
        <div className="w-full flex justify-end items-center pe-5 py-5 gap-2 ">
          <div className="w-auto  h-auto flex justify-between items-center border-[1px] bg-[#025D89] rounded-lg py-1 px-2">
            <Dropdown
              option={pages}
              value={filterPage}
              onChange={(e) => setFilterPage(e.target.value)}
              SelectClass="bg-[#025D89] text-white outline-none "
            />
          </div>
          <div className="w-auto  h-auto flex justify-between items-center border-[1px] bg-[#025D89] rounded-lg py-1 px-2">
            <Dropdown
              option={limit}
              value={filterLimit}
              onChange={(e) => setFilterLimit(e.target.value)}
              SelectClass="bg-[#025D89] text-white outline-none "
            />
          </div>
        </div>
      </div>

      <div>
        <Table columns={columns} data={filterData} tableClass="h-[640px]"/>
      </div>

      {loading &&  <Loader/>}
    </div>
  );
};

export default CustomerList;
